var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralColorfilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42 47.9999C42 53.3099 39.69 58.1099 36 61.3799C32.82 64.2599 28.62 65.9999 24 65.9999C14.07 65.9999 6 57.9299 6 47.9999C6 39.7199 11.64 32.6999 19.26 30.6299C21.33 35.8499 25.77 39.8699 31.26 41.3699C32.76 41.7899 34.35 41.9999 36 41.9999C37.65 41.9999 39.24 41.7899 40.74 41.3699C41.55 43.4099 42 45.6599 42 47.9999Z",
    fill: "#7BA2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24C54 26.34 53.55 28.59 52.74 30.63C50.67 35.85 46.23 39.87 40.74 41.37C39.24 41.79 37.65 42 36 42C34.35 42 32.76 41.79 31.26 41.37C25.77 39.87 21.33 35.85 19.26 30.63C18.45 28.59 18 26.34 18 24C18 14.07 26.07 6 36 6C45.93 6 54 14.07 54 24Z",
    fill: "#437ADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66 47.9999C66 57.9299 57.93 65.9999 48 65.9999C43.38 65.9999 39.18 64.2599 36 61.3799C39.69 58.1099 42 53.3099 42 47.9999C42 45.6599 41.55 43.4099 40.74 41.3699C46.23 39.8699 50.67 35.8499 52.74 30.6299C60.36 32.6999 66 39.7199 66 47.9999Z",
    fill: "#C7D7F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralColorfilter);
export default __webpack_public_path__ + "static/media/referral-colorfilter.19dd79be66dffa0e6121ea3085d43fe9.svg";
export { ForwardRef as ReactComponent };